var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex flex-row" }, [
    _c(
      "div",
      {
        class: ["custom-switch", { "active-switch": _vm.value }],
        attrs: { disabled: _vm.disabled },
        on: { click: _vm.toggleSwitch },
      },
      [
        _c(
          "svg",
          {
            staticClass: "tick-icon",
            attrs: {
              fill: "#FFFFFF",
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 24 24",
              width: "12",
              height: "12",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M 19.980469 5.9902344 A 1.0001 1.0001 0 0 0 19.292969 6.2929688 L 9 16.585938 L 5.7070312 13.292969 A 1.0001 1.0001 0 1 0 4.2929688 14.707031 L 8.2929688 18.707031 A 1.0001 1.0001 0 0 0 9.7070312 18.707031 L 20.707031 7.7070312 A 1.0001 1.0001 0 0 0 19.980469 5.9902344 z",
              },
            }),
          ]
        ),
        _c("div", { staticClass: "slider", class: { active: _vm.value } }),
        _c(
          "svg",
          {
            staticClass: "cancel-icon",
            attrs: {
              width: "12",
              height: "12",
              viewBox: "0 0 12 12",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M6.69354 5.99937L10.2092 1.80875C10.2681 1.7391 10.2185 1.6333 10.1275 1.6333H9.05872C8.99578 1.6333 8.93551 1.66143 8.89399 1.70964L5.99444 5.16634L3.09488 1.70964C3.0547 1.66143 2.99444 1.6333 2.93015 1.6333H1.8614C1.77033 1.6333 1.72078 1.7391 1.7797 1.80875L5.29533 5.99937L1.7797 10.19C1.7665 10.2055 1.75803 10.2245 1.7553 10.2447C1.75257 10.2649 1.75569 10.2854 1.76429 10.3039C1.7729 10.3224 1.78662 10.338 1.80383 10.3489C1.82104 10.3598 1.84102 10.3656 1.8614 10.3654H2.93015C2.9931 10.3654 3.05336 10.3373 3.09488 10.2891L5.99444 6.83241L8.89399 10.2891C8.93417 10.3373 8.99444 10.3654 9.05872 10.3654H10.1275C10.2185 10.3654 10.2681 10.2596 10.2092 10.19L6.69354 5.99937Z",
                fill: "white",
              },
            }),
          ]
        ),
      ]
    ),
    _c("p", { staticClass: "switch-label" }, [_vm._v(_vm._s(_vm.switchText))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }